(() => {

  const CustomerExistsProp = async () => {
    let cart = await UTILS.getCartJson();
    var CustomerPropUpdate;
    cart.items.forEach(function(item){
      // if(document.body.hasAttribute('CustomerExists')){
      //   if(!item.properties['_CustomerExists']){
      //     CustomerPropUpdate = item.properties;
      //     CustomerPropUpdate['_CustomerExists'] = document.body.getAttribute('customerEmail');
      //     lineItemObjUpdate = {id:item.id.toString(),properties:CustomerPropUpdate}
      //     UTILS.updateCartItem(lineItemObjUpdate)
      //     .finally(() =>{ 
      //       document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      //       document.dispatchEvent(new CustomEvent('cart:close',{ bubbles: true }));
      //     })
      //   }
      // }else{
      //   if(item.properties['_CustomerExists'] != undefined){
      //     CustomerPropUpdate = item.properties;
      //     delete CustomerPropUpdate._CustomerExists;
      //     lineItemObjUpdate = {id:item.id.toString(),properties:CustomerPropUpdate}
      //     UTILS.updateCartItem(lineItemObjUpdate)
      //     .finally(() =>{ 
      //       document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      //       document.dispatchEvent(new CustomEvent('cart:close',{ bubbles: true }));
      //     })
      //   }
      // }
    })
  }

  const AllUnderWearItemsInCart = (cart) => {
    let underWearTotalItems = cart.items.filter((item) => {
      return item.product_type == 'Underwear';
    });

    var totalIDs = [], propertiesItem = [];
    var underWearTotalItemsCount = underWearTotalItems.reduce((sum, item) => sum + item.quantity, 0);
    underWearTotalItems.filter(function(item, index){
      totalIDs.push(item.id)
      propertiesItem.push(item.properties);
    })

    return {
      items: underWearTotalItems,
      count: underWearTotalItemsCount,
      Id : totalIDs,
      line_properties : propertiesItem,
    };
  }

  const GetUnderWearItemsInCart = (cart) => {
    let underWearItems = cart.items.filter((item) => {
      return item.product_id == 11509598279 || item.product_id == 11510437255 || item.product_id == 7153610850413 || item.product_id == 7153610784877;
    });

    var underWearItemsCount = underWearItems.reduce((sum, item) => sum + item.quantity, 0);

    return {
      items: underWearItems,
      count: underWearItemsCount
    };
  }

  const GetLongShortItemsInCart = (cart) => {
    let LongShortsItems = cart.items.filter((item) => {
      return item.product_id == 4322199634029 || item.product_id == 7015495762029 || item.product_id == 7156589396077;
    });

    var LongShortsItemsCount = LongShortsItems.reduce((sum, item) => sum + item.quantity, 0);

    return {
      items: LongShortsItems,
      count: LongShortsItemsCount
    };
  }

  const GetBrasItemsInCart = (cart) => {
    let BrasItems = cart.items.filter((item) => {
      return item.product_type == 'Bra' || item.product_type == 'Bras'
    });

    var totalbraIDs = [], propertiesBra = [];
    var BrasItemsCount = BrasItems.reduce((sum, item) => sum + item.quantity, 0);
    BrasItems.filter(function(item, index){
      totalbraIDs.push(item.id)
      propertiesBra.push(item.properties);
    })

    return {
      items: BrasItems,
      count: BrasItemsCount,
      Ids : totalbraIDs,
      line_properties : propertiesBra
    };
  }

  const UpdateProductGrid = ($product, product, color) => {
    // console.log({ $product, color, product });
    if (product) {
      let color_option = product.color_option;

      let size_option = product.size_option;

      let color_variants = product.variants.filter(v => v[color_option.option_id] == color);
      let color_variant = color_variants.find(v => v.available) || color_variants[0];

      // update color name
      if (color_variant) {
        $product.querySelector('.grid-product__options .selected-color').textContent = color_variant[color_option.option_id];
      }
      // add variant coupon
      if (color_variant){
        // console.log('coupon:'+color_variant.coupon);
        $product.querySelector('.grid-product__options .variant_coupon').textContent = color_variant.coupon;
      }
      // update variant url
      if (color_variant) {
        $product.querySelectorAll('a').forEach(($link) => {
          let variant_url = `/products/${ product.handle }?variant=${ color_variant.id }`;
          $link.setAttribute('href', variant_url);
        });
      }
      
      // update variant media
      let $featured_img = $product.querySelector('.featured-image:not(.img-override) img');
      if ($featured_img && color_variant && color_variant.media) {
        $featured_img.setAttribute('data-src', color_variant.media.img_url);
        $featured_img.classList.add('lazyload');

        let $hover_img = $product.querySelector('.hover-image:not(.img-override) img');
        $hover_img.setAttribute('data-src', color_variant.media.hover_img_url);
        $hover_img.classList.add('lazyload');
      }

      // update size selection
      if (color_variants.length && size_option) {
        $product.querySelectorAll(`.variant-input-wrap[data-index="${ size_option.option_id }"] .variant-input`).forEach(($size) => {
          $size.querySelector('input').checked = false;
          let size = $size.dataset.value;
          let size_variant = color_variants.find(v => v[size_option.option_id] == size);
          if (size_variant) {
            let $size_label = $size.querySelector('label');
            $size_label.classList.toggle('disabled', !size_variant.available);
            $size_label.dataset.variant_id = size_variant.id;
          }else{
            let $size_label = $size.querySelector('label');
            // console.log($size)
            $size_label.classList.toggle('disabled', true);
          }
        });
      }

      // update price
      let $price = $product.querySelectorAll('.priceContainerMN'), hiddenSelectorVariant = $product.querySelector('[HiddenSelectorAll]'),
          selected_one_color= $product.querySelector('fieldset[name="Color"] input[type="radio"]:checked') 
                              ? $product.querySelector('fieldset[name="Color"] input[type="radio"]:checked').value
                              : $product.querySelector('fieldset[name="Color"] input[type="radio"][checked]') ? $product.querySelector('fieldset[name="Color"] input[type="radio"][checked]').value
                              : '',
          selected_one_size= $product.querySelector('fieldset[name="Size"] input[type="radio"]:checked') 
                             ? $product.querySelector('fieldset[name="Size"] input[type="radio"]:checked').value
                             : $product.querySelector('fieldset[name="Size"] input[type="radio"][checked]') ? $product.querySelector('fieldset[name="Size"] input[type="radio"][checked]').value
                             : '';

      // console.log(selected_one_color)
      // console.log(selected_one_size)
      if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]')){
        let variant_discount = parseInt(100-hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount),
            variant_price = parseInt(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.price),
            crntVrntPriceWithMoney = theme.Currency.formatMoney(variant_price, theme.settings.moneyFormat);
        if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount > 0){
          let discountedPrice = variant_price * (variant_discount/100), DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
          $price.forEach(function(price){
            if(price.classList.contains('discountedPrice')){
              price.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span style="color:red">${DiscPriceWithMoney}</span>`;
            }else{
              price.innerHTML = `${crntVrntPriceWithMoney}`;
            }
          })
        }else if(hiddenSelectorVariant.querySelector('option[data-color="'+selected_one_color+'"][data-size="'+selected_one_size+'"]').dataset.discount == 0){
          $price.forEach(function(price){
            price.innerHTML = `${crntVrntPriceWithMoney}`;
          })
        }
      }
    }
  }

  var all_products = [];
  const CollectionProductCards = () => {
    document.querySelectorAll('.grid-product:not(.grid-tile):not(.init)').forEach(($product) => {
      $product.classList.add('init');
      let $productJsonData = $product.querySelector('[data-product-json]');
      if (!$productJsonData) return;
      UTILS.convertStringToJS($productJsonData.innerHTML);
      all_products.push(product);

      let color_option = product.options_with_values.find(opt => ['Color'].indexOf(opt.name) !== -1);
      color_option.option_id = `option${ color_option.position }`;
      product.color_option = color_option;

      let size_option = product.options_with_values.find(opt => ['Size'].indexOf(opt.name) !== -1);
      size_option.option_id = `option${ size_option.position }`;
      product.size_option = size_option;

      // remove selected size on load
      $product.querySelectorAll(`.variant-input-wrap[data-index="${ size_option.option_id }"] .variant-input`).forEach(($size) => {
        $size.querySelector('input').checked = false;
        let $color = $product.querySelector(`.variant-input-wrap[data-index="${ color_option.option_id }"] input:checked`) ||
          $product.querySelectorAll(`.variant-input-wrap[data-index="${ color_option.option_id }"] input`)[0];

        let color = $color.value;
        let color_variants = product.variants.filter(v => v[color_option.option_id] == color);

        // update product grid on load
        UpdateProductGrid($product, product, color);

        // set size availability on load
        let size = $size.dataset.value;
        let size_variant = color_variants.find(v => v[size_option.option_id] == size);
        if (size_variant) {
          let $size_label = $size.querySelector('label');
          $size_label.classList.toggle('disabled', !size_variant.available);
          $size_label.dataset.variant_id = size_variant.id;
        }
      });

      // color change functionality
      $product.addEventListener('change', (e) => {
        let $target = e.target;
        let $product = $target.closest('.grid-product');
        // remove override classes to resume images switching
        $product.querySelectorAll('.img-override').forEach(($item) => {
          $item.classList.remove('img-override');
        });
        let product_id = $product.dataset.id;
        let product = all_products.find(p => p.id == product_id);
        if (product) {
          let isColorSwatch = $target.closest('.color-swatch') !== undefined;
          if (isColorSwatch) {
            let color = $target.value;
            UpdateProductGrid($product, product, color);
          }  
        }
      });

      // product-grid event handlers
      $product.addEventListener('click', (e) => {
        let $target = e.target;
        // size selection - ajax add to cart
        let isSizeSwatch = $target.dataset.variant_id;
        if (isSizeSwatch) {
          let isSoldout = $target.classList.contains('disabled');
          if (isSoldout) {
            if (document.body.classList.contains('NewCustom-product')){
              $target.closest('.grid-product__form').lastChild.previousElementSibling.innerHTML = '<span>Sold Out</span>';
              $target.closest('.grid-product__form').lastChild.previousElementSibling.classList.add('disabled');
              return false;
            }else{
              return
            }
          }

          let variant_id = $target.dataset.variant_id;

          if (document.body.classList.contains('NewCustom-product')){
          $target.closest('.grid-product__form').lastChild.previousElementSibling.innerHTML = '<span>Add to cart</span>';
          $target.closest('.grid-product__form').lastChild.previousElementSibling.classList.remove('disabled');
          $target.closest('.grid-product__form').lastChild.previousElementSibling.setAttribute('varaint_id',variant_id);


        }else{

            let ProductMap;
            if(document.body.hasAttribute('CustomerExists')){
              ProductMap.properties['_CustomerExists'] = document.body.getAttribute('customerEmail');
            }
             if ( document.body.getAttribute('CountryEnabled') == null ){ 
               ProductMap = {id: variant_id,quantity: 1}
             }else{
               ProductMap = {id: variant_id,quantity: 1,properties:{'_CountryEnabled': 'USA'}}
             }
              UTILS.addItemsToCart([
                ProductMap
              ]); 
            
        }
  
        }

        // Mobile toggle sizes
        let $mobileToggle = $target.closest('.MobileSizeSelector_Toggle');
        let isMobileToggle = $mobileToggle !== null;
        if (isMobileToggle) {
          $mobileToggle.classList.toggle('open');
        }
      });
    });
  }

  const InitCartGetSetUpsells = async () => {
    
    // remove item from cart
    document.querySelectorAll('.cart__item-remove:not(.init)').forEach(($remove) => {
      $remove.addEventListener('click', (e) => {
        e.preventDefault();
        let key = e.currentTarget.dataset.key;
        let removeItem = {};
        removeItem[key] = 0;
        UTILS.removeItemsFromCart(removeItem);
      });
      $remove.classList.add('init');
    });
  }

  const Accordions = () => {
    document.querySelectorAll('.accordion-trigger a').forEach(($item) => {
      $item.addEventListener('click', (e) => {
        e.preventDefault();
        let $trigger = e.target.closest('.accordion-trigger');
        var contentID = e.target.closest('a').getAttribute('data-accordion');
        let $accordion = document.getElementById(`accordion-${ contentID }`);
        if (!$accordion) return;
        
        if ($accordion.classList.contains('is-expanded')){
          $accordion.classList.remove('is-expanded');
          $trigger.setAttribute('aria-expanded','false');
        }
        else{
          $accordion.classList.add('is-expanded');
          $trigger.setAttribute('aria-expanded','true');
        }  
      });
    });
  }

  const UpdateCartMessaging = async () => {
    let cart = await UTILS.getCartJson();

    let underWearItemsCount = GetUnderWearItemsInCart(cart).count || 0;
    let longShortItemsCount = GetLongShortItemsInCart(cart).count || 0;
    let BraItemsCount = GetBrasItemsInCart(cart).count || 0;
    
    let message;let girlShrtMsg;let BrasMsg;
    
    function newMessageFirst(count, price) {
      let price_format = UTILS.formatMoney(price * 100);
      let remaining = count-underWearItemsCount;
      let cart_section_settings = JSON.parse(document.querySelector('#CartDrawer').dataset.sectionSettings);
      let message = cart_section_settings.cart_dynamic_message 
        || `Want ${count} pairs for $${price}? Add ${remaining} more: Bikini or Thong`;
      message = message.replace(/{count}/g, count).replace(/{price}/g, price_format).replace(/{remaining}/g, remaining);
      //console.log(message);
      return message;
    }

    function newMessageSecond(count, price) {
      let price_format = UTILS.formatMoney(price * 100);
      let remaining = count-longShortItemsCount;
      let girlShrtMsg = `Want ${count} pairs of Slip Short for $${price}? Add ${remaining} more pair${remaining > 1 ? 's' : ''}`;
      girlShrtMsg = girlShrtMsg.replace(/{count}/g, count).replace(/{price}/g, price_format).replace(/{remaining}/g, remaining);
      return girlShrtMsg;
    }

    function BrasMessageThird(price) {
      let price_format = UTILS.formatMoney(price * 100);
      let BrasMsg = `Want $${price} off? Add another bra to your cart for $88 each`;
      return BrasMsg;
    }    

    if(longShortItemsCount < 3){
      girlShrtMsg = newMessageSecond(3, 60);
    }else if(longShortItemsCount >= 3 && longShortItemsCount < 6){
      girlShrtMsg = newMessageSecond(6, 120);
    }else if(longShortItemsCount >= 6 && longShortItemsCount < 9){
      girlShrtMsg = newMessageSecond(9, 180);
    }else if(longShortItemsCount >= 9 && longShortItemsCount < 12){
      girlShrtMsg = newMessageSecond(12, 240);
    }else if(longShortItemsCount >= 12 && longShortItemsCount < 15){
      girlShrtMsg = newMessageSecond(15, 300);
    }else if(longShortItemsCount >= 15 && longShortItemsCount < 18){
      girlShrtMsg = newMessageSecond(18, 360);
    }else if(longShortItemsCount >= 18 && longShortItemsCount < 21){
      girlShrtMsg = newMessageSecond(21, 420);
    }else if(longShortItemsCount >= 21 && longShortItemsCount < 24){
      girlShrtMsg = newMessageSecond(24, 480);
    }else if(longShortItemsCount >= 24 && longShortItemsCount < 27){
      girlShrtMsg = newMessageSecond(27, 540);
    }else if(longShortItemsCount >= 27 && longShortItemsCount < 30){
      girlShrtMsg = newMessageSecond(30, 600);
    }else if(longShortItemsCount >= 30 && longShortItemsCount < 33){
      girlShrtMsg = newMessageSecond(33, 660);
    }else if(longShortItemsCount >= 33 && longShortItemsCount < 36){
      girlShrtMsg = newMessageSecond(36, 720);
    }else if(longShortItemsCount >= 36 && longShortItemsCount < 39){
      girlShrtMsg = newMessageSecond(39, 780);
    }
    
    if (underWearItemsCount < 5) {
      message = newMessageFirst(5, 80);
    }else if (underWearItemsCount >= 5 && underWearItemsCount < 10) {
      message = newMessageFirst(10, 160);
    }else if (underWearItemsCount >= 10 && underWearItemsCount < 15) {
      message = newMessageFirst(15, 240);
    }else if (underWearItemsCount >= 15 && underWearItemsCount < 20) {
      message = newMessageFirst(20, 320);
    }else if (underWearItemsCount >= 20 && underWearItemsCount < 25) {
      message = newMessageFirst(25, 400);
    }else if (underWearItemsCount >= 25 && underWearItemsCount < 30) {
      message = newMessageFirst(30, 480);
    }else if (underWearItemsCount >= 30 && underWearItemsCount < 35) {
      message = newMessageFirst(35, 560);
    }else if (underWearItemsCount >= 35 && underWearItemsCount < 40) {
      message = newMessageFirst(40, 640);
    }else if (underWearItemsCount >= 40 && underWearItemsCount < 45) {
      message = newMessageFirst(45, 720);
    }else if (underWearItemsCount >= 45 && underWearItemsCount < 50) {
      message = newMessageFirst(50, 800);
    }else if (underWearItemsCount >= 50 && underWearItemsCount < 55) {
      message = newMessageFirst(55, 580);
    }else if (underWearItemsCount >= 55 && underWearItemsCount < 60) {
      message = newMessageFirst(60, 960);
    }

    if(BraItemsCount > 0){
      let offNow = (BraItemsCount+1)*10;
      BrasMsg = BrasMessageThird(offNow);
    }                 
    
    if (message !== undefined && message !== '') {
      if(document.querySelectorAll('.BikniThong__MessagesOffer').length > 0){
        document.querySelectorAll('.BikniThong__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${message}`;target.style.display = "block";
        })
      }
    }
    
    if(girlShrtMsg !== undefined){
      if(document.querySelectorAll('.GirlShot__MessagesOffer').length > 0){
        document.querySelectorAll('.GirlShot__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${girlShrtMsg}`;target.style.display = "block";
        })
      }
    }

    if(BrasMsg !== undefined){
      if(document.querySelectorAll('.Bra__MessagesOffer').length > 0){
        document.querySelectorAll('.Bra__MessagesOffer').forEach( (target) =>{
          target.firstChild.innerHTML = `${BrasMsg}`;target.style.display = "block";
        })
      }
    }
    
  }

  const DOMReady = () => {
    CustomerExistsProp();
    UpdateCartMessaging();
    CollectionProductCards();
    InitCartGetSetUpsells();
    Accordions();

    document.addEventListener('cart:updated', CustomerExistsProp);
    document.addEventListener('cart:updated', UpdateCartMessaging);
    document.addEventListener('cart:updated', InitCartGetSetUpsells);
  }
  document.addEventListener('DOMContentLoaded', DOMReady);

  // $(document).on('click', '.ElmNextRow', function(e){
  //   e.preventDefault();
  //   $(this).parents('.variant-input-wrap').children('.variant-input').css('display','inline-block');
  //   $(this).hide();
  // })

  // function ChevronsHomepage(){
  //   if( document.querySelectorAll('.TemplateIndexWeDo').length > 0 ){

  //   $('.ElmNextRow').remove();
  //   $('.variant-input').css('display','inline-block');
      
  //     $('.IndexGridLayoutWp').each( function(){
  //       var counter = 0;
        
  //       if ( $(window).width() >= 1703  && $(window).width() < 1920   ) {
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 15 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 15);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 14 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 14){$(this).css('display','none');}
  //           }) 
  //         }
          
  //       }else if ( $(window).width() >= 1512  && $(window).width() < 1703   ) {
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 12 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 12);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 11 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 11){$(this).css('display','none');}
  //           }) 
  //         }
          
  //       }else if( $(window).width() >= 1440 && $(window).width() < 1512 ){
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 12 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 12);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 11 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 11){$(this).css('display','none');}
  //           }) 
  //         }        
  
  //       }else if( $(window).width() >= 1366 && $(window).width() < 1440 ){
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 11 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 11);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 10 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 10){$(this).css('display','none');}
  //           }) 
  //         }        
  
  //       }else if( $(window).width() >= 1280 && $(window).width() < 1366 ){
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 10 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 10);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 9 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 9){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 1024 && $(window).width() < 1280 ){
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 11 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 11);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 10 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 10){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 989 && $(window).width() < 1024 ){   
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 17 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 17);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 16 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 16){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 820 && $(window).width() < 989 ){  
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 13 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 13);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 12 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 12 ){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 768 && $(window).width() < 820 ){   
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 10 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 10);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 9 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 9 ){$(this).css('display','none');}
  //           }) 
  //         }          
  
  //       }else if( $(window).width() >= 425 && $(window).width() < 768 ){   
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 10 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 10);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 9 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 9 ){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 414 && $(window).width() < 425 ){   
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 9 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 9);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 8 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 8 ){$(this).css('display','none');}
  //           }) 
  //         }          
  
  //       }else if( $(window).width() >= 411 && $(window).width() < 414 ){    
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 9 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 9);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 8 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 8 ){$(this).css('display','none');}
  //           }) 
  //         }          
  
  //       }else if( $(window).width() >= 390 && $(window).width() < 411 ){ 
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 9 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 9);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 8 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 8 ){$(this).css('display','none');}
  //           }) 
  //         }       
  
  //       }else if( $(window).width() >= 375 && $(window).width() < 390 ){  
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 8 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 8);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 7 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 7 ){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() >= 360 && $(window).width() < 375 ){       
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 8 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 8);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 7 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 7 ){$(this).css('display','none');}
  //           }) 
  //         }          
  
  //       }else if( $(window).width() >= 320 && $(window).width() < 360 ){  
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 7 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 7);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 6 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 6 ){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }else if( $(window).width() < 320 ){
  
  //         var GetColor = $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').length
  //         if ( GetColor > 7 ){    
  //           $(this).children('.grid-product__content').children('.grid-product__form').children('.variant-wrapper').children('.TemplateIndexWeDo').children('.variant-input-wrap').children('.variant-input').each(function(index){
  //             var final = parseInt(GetColor - 7);
  //             if ( index == 0 ) {counter = 0;} else {counter++;}
  //             if ( index == 6 ){$(this).after(`<div class="ElmNextRow">+${final}</div>`);}
  //             if( counter > 6 ){$(this).css('display','none');}
  //           }) 
  //         }         
  
  //       }
  //     })
  //   }
  // }

  // window.addEventListener('resize', function(event) {
  //   ChevronsHomepage();
  // }, true);
  // ChevronsHomepage();

})();

window.addEventListener('resize',function(){
  var TestimonialSlide = new Flickity(document.querySelector('.NewTestmnlBlckInit.js-flickity'))
  TestimonialSlide.resize();
})